import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import ImgSignupConfirm from 'legacy/assets/img/signup-confirm.png'
import { ButtonAction } from 'legacy/components/Button/ButtonAction'
import { I18n } from 'legacy/components/I18n/i18n'
import { resendEmail } from 'legacy/services/account'
import { screen } from 'legacy/styles/screen'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const Title = styled.header`
  margin: 0;
  margin-bottom: 24px;
  padding-bottom: 20px;

  color: ${getToken('color-neutral-darkest')};
  font-weight: bold;
  font-size: 22px;
  line-height: 24px;
  text-align: center;

  border-bottom: 1px solid ${getToken('color-neutral-light')};
`

const Text = styled.div`
  margin-top: 20px;
  padding: 0 20px;

  font-size: 14px;
  line-height: 20px;
  text-align: center;
`

const ActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`

const Button = styled(ButtonAction)`
  flex-basis: 100%;
  margin-top: 20px;

  ${screen.md} {
    flex-basis: 48%;
  }
`

function SignupSuccess(props) {
  const { email, onClose, onView, onResendEmail } = props

  const [emailSent, setEmailSent] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let timer
    if (emailSent) {
      timer = window.setTimeout(() => {
        setEmailSent(false)
      }, 3000)
    }
    return () => window.clearTimeout(timer)
  }, [emailSent])

  useEffect(() => {
    onView()
  }, [onView])

  const handleResendEmail = useCallback(
    email => {
      setLoading(true)
      resendEmail({
        email,
      })
        .then(() => {
          setEmailSent(true)
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false)
        })
      onResendEmail()
    },
    [onResendEmail]
  )

  return (
    <Container>
      <Title aria-label="Account created">{I18n.get('lb.outletDialog.signUp.success.title')}</Title>
      <img src={ImgSignupConfirm} alt="signup" width="180px" height="185px" />
      <Text>
        <strong>{I18n.get('lb.outletDialog.signUp.success.text')}</strong>
      </Text>
      <ActionsContainer>
        <Button square upperCase size="sm" onClick={onClose}>
          {I18n.get('lb.outletDialog.signUp.success.close')}
        </Button>
        <Button
          square
          upperCase
          size="sm"
          activated
          disabled={emailSent || loading}
          onClick={() => handleResendEmail(email)}
        >
          {I18n.get(
            emailSent || loading
              ? 'lb.outletDialog.signUp.success.emailSent'
              : 'lb.outletDialog.signUp.success.resendEmail'
          )}
        </Button>
      </ActionsContainer>
    </Container>
  )
}

SignupSuccess.propTypes = {
  email: PropTypes.string,
  onClose: PropTypes.func,
  onView: PropTypes.func,
  onResendEmail: PropTypes.func,
}

SignupSuccess.defaultProps = {
  email: undefined,
  onClose: () => {},
  onView: () => {},
  onResendEmail: () => {},
}

export { SignupSuccess }
